import {
  ClusteringMethodValue,
  getCapitalizableProjectClusteringStatus,
  CapitalizableProjectClusteringStatus,
  CapitalizableProjectClusteringStatusInput,
  CapitalizableProjectClusteringStatusReason,
} from '@common/neo.tax';

export type {
  CapitalizableProjectClusteringStatusReason,
  CapitalizableProjectClusteringStatus,
  CapitalizableProjectClusteringStatusInput,
} from '@common/neo.tax';

const REASON_TEXT: Record<CapitalizableProjectClusteringStatusReason, string> = {
  'default-active': 'Active by default (capitalizing)',
  'default-active-boundary-extend': 'Active by default (capitalization may extend beyond the last sync)',
  'default-active-fresh-main': 'Active by default (newly created capitalizable project)',
  included: 'Manually included',
  excluded: 'Manually excluded',
  'capitalization-ended': 'Inactive (capitalization ended)',
  'no-recent-activity': 'Inactive (no recent activity)',
  'capitalization-not-started': 'Inactive (capitalization not started)',
  'not-applicable': 'Not applicable for this clustering method',
};

export type CapitalizableProjectClusteringStatusWithText = CapitalizableProjectClusteringStatus & {
  reasonText: string;
};

export const computeCapitalizableProjectClusteringStatus = (
  project: CapitalizableProjectClusteringStatusInput,
  clusteringMethod: ClusteringMethodValue | null,
  lastCompletedAscSyncPeriodEnd?: Date | string | null,
): CapitalizableProjectClusteringStatusWithText => {
  const status = getCapitalizableProjectClusteringStatus(project, clusteringMethod, lastCompletedAscSyncPeriodEnd);
  return { ...status, reasonText: REASON_TEXT[status.reason] };
};
